import React from 'react';

const Logo: React.FC = () => {
  return (
    <img 
      src="/terrain-pro-logo.svg" 
      alt="Terabase Terrain Pro" 
      style={{ height: '35px', width: 'auto' }}
    />
  );
};

export default Logo;

